module.exports = __webpack_public_path__ + "static/media/rss-square.e5b2d2ba.svg";